module.exports = __webpack_public_path__ + "static/media/vattenfall.197710fd.png";